import React from 'react';

import type { GlobalSideNavigationProps } from '../../common/types';
import { useLocalSideNavUserData } from '../../controllers/user-state/persistence/use-local-side-nav-user-data';

import { GlobalSideNavContent } from './GlobalSideNavContent';
import { GlobalSideNavWrapper } from './GlobalSideNavWrapper';

export function GlobalSideNavigationWithLocalStore(props: GlobalSideNavigationProps) {
	const { app } = props;

	// This is user data for the menu and the sidebar
	const userStoreProps = useLocalSideNavUserData({ app });

	return (
		<GlobalSideNavWrapper {...userStoreProps}>
			<GlobalSideNavContent {...props} />
		</GlobalSideNavWrapper>
	);
}
